/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum ConfigStates {
    Visible = 'Visible',
    Hidden = 'Hidden',
}
